<template>
    <div class="tw:mb-4 tw:sm:mb-6">
        <div class="tw:flex tw:items-center tw:justify-between tw:flex-wrap tw:gap-3 tw:sm:gap-4">
            <!-- Título y Breadcrumbs -->
            <div class="tw:flex-1 tw:min-w-0 tw:basis-60">
                <h4 class="tw:text-slate-900 tw:text-xl tw:sm:text-2xl tw:font-semibold tw:mb-1 tw:tracking-tight tw:break-words">
                    {{ title }}
                </h4>

                <BreadcrumbSub :items="items" />

                <ul class="tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:text-xs tw:text-slate-500 tw:m-0 tw:p-0 tw:list-none">
                    <li>
                        <router-link to="/"
                            class="tw:text-slate-500 tw:no-underline tw:hover:text-slate-900 tw:transition-colors">
                            Dashboard
                        </router-link>
                    </li>
                    <li class="tw:text-slate-300">/</li>
                    <li class="tw:text-slate-700 tw:font-medium">
                        {{ title }}
                    </li>
                </ul>
            </div>

            <!-- Botón de Regresar -->
            <div class="tw:shrink-0 tw:text-right">
                <BackPage ref="btn_back_page" />
            </div>
        </div>
    </div>
</template>

<script>
import BackPage from './BackPage.vue';
import BreadcrumbSub from './BreadcrumbSub.vue';

export default {
    name: 'BreadcrumbPage',
    props: {
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    components: {
        BackPage,
        BreadcrumbSub,
    }
}
</script>